
import React, { useState, useEffect } from 'react';
import { axiosInstance } from '../../../utils';
import { useParams } from "react-router-dom";
import edit from "../../../assets/svgs/edit_pen.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import  { ReactSVG } from "react-svg";

const AdminProfile = () => {
  const [data, setData] = useState(null);
  const [editContact, setEditContact] = useState("");
  const [loading, setLoading] = useState(true);
  const [saveUpdate, setSaveUpdate] = useState(false);
  const [originalContact, setOriginalContact] = useState("");

  const id = useParams();
 
  useEffect(() => {
    getProfile();
  }, []);
  
  const token = localStorage?.getItem("token");
  

 const getProfile = async () => {
  try {
    await axiosInstance.post("/api/admin/view-admin-profile", "",{
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        userId: id?.id
      }
    })
    .then(res =>  { setData(res.data?.data);
      setLoading(false);
      if(res?.data?.data){
        setEditContact(res?.data?.data?.contactNumber);
        setOriginalContact(res?.data?.data?.contactNumber);
      }
    })
    .catch(err => {
      toast.error(err.response.data.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        });
    })
  } catch (error) {
    console.log(error);
  }
 }

 const handleEditChange = (e) => {
  let value = e.target.value;
  const regex =  /^[0-9]+$/;
  if(value.match(regex) || value === "") {
    setEditContact(value);
  }
 }
 
   const editAction = async () => {
   
     try{
    
      if( editContact === "") {
        toast.error("Please, Fill Out Contact Number to Update!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
      } else if(originalContact === editContact) {
        toast.error("Please, make changes to the Contact Number before updating!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
     
      await axiosInstance.get("/api/admin/update-admin-contact", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          userId: data?.userId,
          contactNumber: editContact
        }
      })
      .then(res => {
        setSaveUpdate(true);
        toast.success("Successfully Updated Contact Number!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
      })
      .catch(err => {
        console.log(err)
      })
    }
  }
     catch(err) {
      console.log(err);
     }
   }
  

  return (
    <section className='container py-10'>
      <div className='p-4 bg-white rounded-lg min-h-max border-t-8 border-t-primary-yellow-500'>
        <p className='border-b-2 border-b-secondary-n-50 border-dashed pb-3 mb-6 font-poppins text-lg font-medium text-secondary-n-800'>Personal Information</p>
        {
          loading ? (
            <p className='mx-auto font-poppins font-medium text-base '>loading...</p>
          ) : (

        <div className='grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-6'>
          
            <div className='space-y-2'>
               <label htmlFor='userType' className='font-poppins font-medium text-base text-secondary-n-500'>User Type:</label>
               <input type='text' value={data?.userType}  className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>
            <div className='space-y-2'>
               <label htmlFor='userId' className='font-poppins font-medium text-base text-secondary-n-500'>User ID:</label>
               <input type='text' value={data?.userId}  className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>

            <div className='space-y-2'>
               <label htmlFor='username' className='font-poppins font-medium text-base text-secondary-n-500'>User name:</label>
               <input type='text' value={data?.username}  className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>

            <div className='space-y-2'>
               <label htmlFor='email' className='font-poppins font-medium text-base text-secondary-n-500'>Email:</label>
               <input type='email' value={data?.email} className='border-b-2 border-b-secondary-n-50  w-full outline-none' readOnly />
            </div>

            <div className='space-y-2 relative'>
               <label htmlFor='contactNumber' className='font-poppins font-medium text-base text-secondary-n-500'>Contact Number:</label>
              
                 <input type='tel' value={editContact} maxLength={11} className='border-b-2 border-b-secondary-n-50  w-full outline-none'  onChange={handleEditChange} />
               

               <div className='absolute   top-4 right-0'>
                {  saveUpdate ?  (
                  <div className='flex justify-center items-center text-white w-16 p-3 h-8 rounded-md bg-primary-green'>
                       Saved!
                    </div>
                ) : (
                  
                  <button className='flex justify-center items-center text-white w-16 h-8 rounded-md bg-secondary-n-100' onClick={editAction}>
                  {/* <img src={edit} alt='edit icon' className='cursor-pointer' onClick={editAction} /> */}
                  {/* <ReactSVG src={edit}  /> */}
                  Update
                </button>
                ) }
               </div>
            </div>

            <div className='space-y-2'>
               <label htmlFor='status' className='font-poppins font-medium text-base text-secondary-n-500'>Status:</label>
               <div className='text-white bg-primary-green p-1 uppercase rounded-lg max-w-max'>{data?.status}</div>  
            </div>
        </div>
          )
        }
      </div>
      <ToastContainer />
    </section>
  )
}


export default AdminProfile;